import { Component, ElementRef, inject } from '@angular/core';
import { LayoutMenuComponent } from '../menu/layout-menu.component';
import { DrawerModule } from 'primeng/drawer';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'sm-layout-sidebar',
  standalone: true,
  imports: [LayoutMenuComponent, DrawerModule],
  templateUrl: `./layout-sidebar.component.html`,
  styleUrl: `./layout-sidebar.component.scss`,
})
export class LayoutSidebarComponent {
  private layoutService = inject(LayoutService);

  constructor(public el: ElementRef) {}

  get mobileMenuVisible(): boolean {
    return this.layoutService.layoutState().staticMenuMobileActive ?? false;
  }

  set mobileMenuVisible(value: boolean) {
    this.layoutService.layoutState.update(prev => ({
      ...prev,
      staticMenuMobileActive: value,
    }));
  }

  onDrawerHide(): void {
    this.mobileMenuVisible = false;
  }
}
